import { createContext, useContext, useState, useCallback, useMemo, ReactNode } from "react";

export interface FABConfig {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  variant?: "default" | "destructive";
  disabled?: boolean;
  hidden?: boolean;
}

interface FABContextValue {
  config: FABConfig | null;
  setFAB: (config: FABConfig | null) => void;
}

const FABContext = createContext<FABContextValue>({ config: null, setFAB: () => {} });

export function FABProvider({ children }: { children: ReactNode }) {
  const [config, setConfig] = useState<FABConfig | null>(null);

  const setFAB = useCallback((c: FABConfig | null) => setConfig(c), []);

  const fabValue = useMemo(() => ({ config, setFAB }), [config, setFAB]);

  return (
    <FABContext.Provider value={fabValue}>
      {children}
    </FABContext.Provider>
  );
}

export function useFAB() {
  return useContext(FABContext);
}
